export default {
  VALIDATE_USER_SESSION: 'VALIDATE_USER_SESSION',
  SET_SESSION_VALIDATED: 'SET_SESSION_VALIDATED',
  RECEIVE_CURRENT_USER: 'RECEIVE_CURRENT_USER',
  LOGOUT_CURRENT_USER: 'LOGOUT_CURRENT_USER',
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  SET_LOADING: 'SET_LOADING',
  SET_USER_TYPE: 'SET_USER_TYPE'
};
